var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewFilterRtl = function SvgNewFilterRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "new-filter-rtl_svg__a",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h100v100H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3A3D3F",
    mask: "url(#new-filter-rtl_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.704 10c-2.182 0-3.951 1.79-3.951 4v16l.005.206C69.864 32.32 71.59 34 73.704 34s3.84-1.68 3.945-3.794l.005-.206v-4h8.889C88.453 26 90 24.433 90 22.5S88.452 19 86.543 19h-8.889v-5c0-2.209-1.768-4-3.95-4M13.28 19.005C11.453 19.098 10 20.627 10 22.5s1.453 3.402 3.28 3.495l.177.005h48.867v-7H13.457zM73.704 66c-2.182 0-3.951 1.79-3.951 4v16l.005.206C69.864 88.32 71.59 90 73.704 90s3.84-1.68 3.945-3.794l.005-.206v-4h8.889C88.453 82 90 80.433 90 78.5S88.452 75 86.543 75h-8.889v-5c0-2.209-1.768-4-3.95-4M13.28 75.005C11.453 75.098 10 76.627 10 78.5s1.453 3.402 3.28 3.495l.177.005h48.867v-7H13.457zM26.296 38c-2.113 0-3.84 1.68-3.945 3.794l-.005.206v4h-8.889C11.547 46 10 47.567 10 49.5s1.548 3.5 3.457 3.5h8.889v5c0 2.209 1.768 4 3.95 4s3.951-1.79 3.951-4V42l-.005-.206C30.136 39.68 28.41 38 26.296 38m11.38 15h48.867l.178-.005C88.547 52.902 90 51.373 90 49.5s-1.453-3.402-3.28-3.495L86.544 46H37.676z"
  }))));
};
export default SvgNewFilterRtl;